<template>
    <CardDropdownSm :item="categoryData">
        <template #icon>
            <NewFolderIcon class="flex-shrink-0 w-4 h-4 ct-fg-2" />
        </template>
        <template #inside>
            <draggable
                :data-text="$t('shared.empty')"
                :class="[
                    category.variants.length ? '' : 'ct-card-empty',
                    dragOver ? 'is-dragging' : '',
                ]"
                class="space-y-2"
                v-model="category.variants"
                item-key="id"
                group="variants"
                @change="setVariants"
                @dragenter="dragOver = true"
                @dragleave="dragOver = false"
            >
                <template #item="{ element }">
                    <div class="relative mt-2 group" v-if="!element._deleted">
                        <VariantCard
                            class="ct-drag-item"
                            :variant="element"
                            @edit="$emit('editVariant', element)"
                            @delete="askAndRemoveVariant(element)"
                            @duplicate="cloneVariant(element)"
                            @click="$emit('editVariant', element)"
                        />
                        <div
                            class="absolute top-1/2 -left-2 -translate-y-1/2 ct-fg-4 opacity-0 group-hover:opacity-100 cursor-move pr-2 h-full flex items-center"
                        >
                            <DragDropIcon />
                        </div>
                    </div>
                </template>
            </draggable>
        </template>
    </CardDropdownSm>
</template>

<script>
import draggable from "vuedraggable";
import { mapState, mapActions, mapMutations } from "vuex";
import { NewFolderIcon, PencilLineIcon, TrashBinIcon, AddIcon, DragDropIcon } from "@easy/ui/icons";
import { CardDropdownSm } from "@easy/ui/cards";
import VariantCard from "./VariantCard.vue";

export default {
    components: {
        draggable,
        NewFolderIcon,
        DragDropIcon,
        CardDropdownSm,
        VariantCard,
    },
    props: {
        category: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            dragOver: false,
        };
    },
    emits: ["editCategory", "deleteCategory", "editVariant", "addVariant"],
    computed: {
        ...mapState("pricing", ["pricing"]),
        categoryData() {
            return {
                title: this.category.name,
                actions: [
                    {
                        label: this.$t("pricing.variants.add_variant"),
                        icon: AddIcon,
                        handler: () => this.$emit("addVariant"),
                    },
                    {
                        label: this.$t("shared.rename"),
                        icon: PencilLineIcon,
                        handler: () => this.$emit("editCategory"),
                    },
                    { isDivider: true },
                    {
                        label: this.$t("pricing.variants.delete_category"),
                        icon: TrashBinIcon,
                        isDanger: true,
                        handler: () => this.$emit("deleteCategory"),
                    },
                ],
            };
        },
    },
    methods: {
        ...mapActions("modals", ["showConfirmModal"]),
        ...mapActions("pricing", ["cloneVariant", "removeVariant"]),
        ...mapMutations(["showAlert"]),
        ...mapMutations("pricing", ["setVariants"]),
        async askAndRemoveVariant(variant) {
            // if (variant.ecId) {
            //     this.showAlert({
            //         type: "wrong",
            //         title: this.$t("pricing.variants.delete_ec_product"),
            //     });
            //     return false;
            // }
            const decision = await this.showConfirmModal({
                title: this.$t("pricing.variants.delete_variant_confirm"),
                description: this.$t("pricing.variants.delete_variant_message"),
                ctaLabel: this.$t("shared.delete"),
            });
            if (decision) {
                this.removeVariant(variant);
            }
        },
    },
};
</script>
